import React, { useState } from 'react';
import { RiLogoutCircleRLine } from "react-icons/ri";
import { GiHamburgerMenu } from "react-icons/gi";
import logo from '../../Images/jaiclub2.png';

const Sidebar = ({ onSelect, section }) => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { key: 'Account', label: 'Account', icon: '💻' },
    { key: 'Payments', label: 'Statement of Account', icon: '🧾' },
    { key: 'Booking', label: 'Booking', icon: '🛎️' },
     { key: 'Sports Booking', label: 'Sports Booking', icon: '🏃‍♂️', path: '/dashboard/booking' },
    //{ key: 'Takeaway', label: 'Takeaway', icon: '🥡' },
    { key: 'Members', label: 'Members', icon: '👥' },
    // { key: 'Cart', label: 'Cart', icon: '👥' },
  ];

  return (
    <>
      {/* Hamburger menu */}
      {!isOpen && (
        <GiHamburgerMenu
          onClick={() => setIsOpen(true)}
          style={{
            position: 'fixed',
            top: '20px',
            left: '20px',
            fontSize: '30px',
            cursor: 'pointer',
            zIndex: 1100,
          }}
          aria-label="Open sidebar"
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter') setIsOpen(true);
          }}
        />
      )}

      {/* Backdrop */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 999,
          }}
          aria-hidden="true"
        ></div>
      )}

      {/* Sidebar */}
      <nav
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          width: '70vw',
          maxWidth: '280px',
          backgroundColor: '#B53737',
          color: '#fff',
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          padding: '1rem 0.5rem',
          boxShadow: isOpen ? '2px 0 5px rgba(0,0,0,0.3)' : 'none',
        }}
        aria-hidden={!isOpen}
      >
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src={logo} alt="Logo" style={{ width: '100px', height: 'auto' }} />
        </div>

        {/* Navigation Items */}
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            marginTop: '2rem',
            flexGrow: 1,
            overflowY: 'auto',
          }}
        >
          {navItems.map(({ key, label, icon }) => (
            <li
              key={key}
              onClick={() => {
                if (onSelect) onSelect(key);
                setIsOpen(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '0.75rem',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '1rem',
                backgroundColor: section === key ? '#7B2E2E' : 'transparent',
                padding: '0.5rem',
                userSelect: 'none',
              }}
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  if (onSelect) onSelect(key);
                  setIsOpen(false);
                }
              }}
              role="button"
              aria-current={section === key ? 'page' : undefined}
            >
              <span style={{ marginRight: '8px' }}>{icon}</span> {label}
            </li>
          ))}
        </ul>

        {/* Logout */}
        <div
          style={{
            padding: '12px 16px',
            cursor: 'pointer',
            fontSize: '1.1rem',
            display: 'flex',
            alignItems: 'center',
            userSelect: 'none',
          }}
          onClick={() => {
            sessionStorage.clear();
            setIsOpen(false);
            window.location.href = '/';
          }}
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              sessionStorage.clear();
              setIsOpen(false);
              window.location.href = '/';
            }
          }}
          role="button"
          aria-label="Logout"
        >
          <RiLogoutCircleRLine style={{ marginRight: '8px' }} /> Logout
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
